export default {
  props: {
    tag: {
      type: String,
      default: 'span',
    },

    label: {
      type: String,
      default: '',
    },

    dataTestid: {
      type: String,
      default: 'title',
    },
  },

  render(createElement) {
    const defaultSlot = this.$slots.default ? this.$slots.default : this.label

    return createElement(
      this.tag,
      {
        attrs: {
          'data-testid': this.dataTestid,
        },
        class: ['title', this.class],
      },
      defaultSlot
    )
  },
}
